import * as THREE from "three";
import { MeshAttributes } from '../ObjectLoader';
import { MaterialAttributes } from './MaterialSet';


export class MaterialFlags {
	public useAlpha = false;
	public forceSingle = false;
	public forceDouble = false;
	public noDepthWrite: boolean;

	constructor(keywords:string[]){
		this.useAlpha = keywords.indexOf('transparent') > -1;
		this.forceSingle = keywords.indexOf('single-side') > -1;
		this.forceDouble = keywords.indexOf('double-side') > -1;
		this.noDepthWrite = keywords.indexOf('no-depth-write') > -1;
	}

	setupMaterial(material:THREE.ShaderMaterial, attributes: MaterialAttributes = 0){
		if (this.useAlpha)
			material.transparent = true;
		else
			material.side = THREE.DoubleSide;

		if (this.forceDouble)
			material.side = THREE.DoubleSide;
		else if (this.forceSingle)
			material.side = THREE.FrontSide;

		if (this.noDepthWrite)
			material.depthWrite = false;
			// material.depthTest = false;

		if (attributes & MaterialAttributes.Correction){
			material.defaultAttributeValues[MeshAttributes.CorrectionU] = [0,0,0];
			material.defaultAttributeValues[MeshAttributes.CorrectionV] = [0,0,0];
		}

		if (attributes & MaterialAttributes.Sizing) {
			material.defaultAttributeValues[MeshAttributes.Offset] = [0,0,0];
		}
	}
}



// WEBPACK FOOTER //
// ./src/script/app3D/data/MaterialFlags.ts